module.exports = KsysAppTemplateV2dot36dot3;